import { App } from 'vue'

import CheckoutView from './CheckoutView.vue'

const register = (app: App<Element>): void => {
  app
    .component('checkout-view', CheckoutView)
}

export default {
  register,
}
